import styled from 'styled-components';

export const StyledDashboard = styled.div`
  display: flex;
  gap: 20px;
  color: var(--color-text-main);
  width: 100%;

  > div {
    width: 100%;
    height: auto;
    
    display: flex;
    flex-direction: column;
    gap: 20px;
  }



  @media (min-width: 1280px) {
    .chart {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 1280px) {
    flex-direction: column;
    gap: 20px;
    
    > div {
      height: 400px;
      min-width: 457px;
      min-height: 400px;
    }
  }
  }
`;
